import RouteView from '@/layouts/RouteView'

export default {
  path: '/shop-mana/index',
  name: 'Store.Search',
  // redirect: '/shop-mana/index',
  meta: { icon: 'shop', title: '鱼住门店管理', bread: true },
  component: () =>
    import(/* webpackChunkName: 'clientMana' */ '@/views/shop-mana/search/index.vue'),
}
